import React from "react";
import cx from "classnames";
const ColorBox = (props) => {
  const { prefix, color } = props;
  const boxClassName = !!prefix ? prefix + "-color-box" : "color-box";

  return (
    <div
      className={cx(boxClassName)}
      style={{ backgroundColor: color || "#fff" }}
    ></div>
  );
};

export default ColorBox;
